import { useContext } from "react";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import RentPercSlider from "./RentPercSlider";

const EffortRateBar = (props) => {
  const { effortObj, handleRentPercSave, hideSlider = false } = props;
  const { _t } = useTranslator();
  const { user } = useContext(AuthContext);

  return (
    <div className="score-meter-capsule-wrapper">
      <p className="score-meter-capsule-head">{_t("effortRateAndMaxRent")}</p>
      <div class="progress-bar-inner-wrapper pdf-score-capsule">
        <div class="d-flex gap-2">
          <p class="progress-step">
            <span
              class="progress-fill  progress-filler-dark-green"
              style={{
                width:
                  effortObj?.effort_rate < 10
                    ? `${effortObj?.effort_rate * 10}%`
                    : "100%",
              }}
            ></span>
          </p>
          <p class="progress-step">
            <span
              class="progress-fill progress-filler-light-green"
              style={{
                width:
                  effortObj?.effort_rate < 20
                    ? `${Math.max((effortObj?.effort_rate - 10) * 10, 0)}%`
                    : "100%",
              }}
            ></span>
          </p>
          <p class="progress-step rotate-180">
            <span
              class="progress-fill progress-filler-yellow"
              style={{
                width:
                  effortObj?.effort_rate < 30
                    ? `${Math.max((effortObj?.effort_rate - 20) * 10, 0)}%`
                    : "100%",
              }}
            ></span>
          </p>
          <p class="progress-step">
            <span
              class="progress-fill  progress-filler-orange"
              style={{
                width:
                  effortObj?.effort_rate < 40
                    ? `${Math.max((effortObj?.effort_rate - 30) * 10, 0)}%`
                    : "100%",
              }}
            ></span>
          </p>
          <p class="progress-step">
            <span
              class="progress-fill progress-filler-red"
              style={{
                width:
                  effortObj?.effort_rate < 50
                    ? `${Math.max((effortObj?.effort_rate - 40) * 10, 0)}%`
                    : "100%",
              }}
            ></span>
          </p>
        </div>
        <div class="d-flex justify-content-between gap-2">
          <span class="score-limit">
            0%
            <br /> <span className="font-weight-bold">€0</span>
          </span>
          <span class="score-limit">
            10%
            <br />{" "}
            <span className="font-weight-bold">
              €
              {effortObj?.monthly_sal != "N/A" &&
              !Number.isNaN(effortObj?.monthly_sal)
                ? Math.ceil((effortObj?.monthly_sal * 10) / 100)
                : 0}
            </span>
          </span>
          <span class="score-limit">
            20%
            <br />{" "}
            <span className="font-weight-bold">
              €
              {effortObj?.monthly_sal != "N/A" &&
              !Number.isNaN(effortObj?.monthly_sal)
                ? Math.ceil((effortObj?.monthly_sal * 20) / 100)
                : 0}
            </span>
          </span>
          <span class="score-limit">
            30%
            <br />{" "}
            <span className="font-weight-bold">
              €
              {effortObj?.monthly_sal != "N/A" &&
              !Number.isNaN(effortObj?.monthly_sal)
                ? Math.ceil((effortObj?.monthly_sal * 30) / 100)
                : 0}
            </span>
          </span>
          <span class="score-limit">
            40%
            <br />{" "}
            <span className="font-weight-bold">
              €
              {effortObj?.monthly_sal != "N/A" &&
              !Number.isNaN(effortObj?.monthly_sal)
                ? Math.ceil((effortObj?.monthly_sal * 40) / 100)
                : 0}
            </span>
          </span>
          <span class="score-limit">
            50%
            <br />{" "}
            <span className="font-weight-bold">
              €
              {effortObj?.monthly_sal != "N/A" &&
              !Number.isNaN(effortObj?.monthly_sal)
                ? Math.ceil((effortObj?.monthly_sal * 50) / 100)
                : 0}
            </span>
          </span>
        </div>
      </div>
      {user?.role == "landlord" && (
        <div className="d-flex justify-content-between align-items-end gap-1 effort-rate">
          <span className="effort-rate-head">{_t("effortRate")}</span>
          {hideSlider && <span className="flex-1 dotted-border-b"></span>}
          <span className="effort-rate-percentage">
            {effortObj?.effort_rate != "N/A" ? effortObj?.effort_rate : 0}%
          </span>
        </div>
      )}
      {!hideSlider && (
        <div className="effort-rate-slider">
          <RentPercSlider
            effortRatePecentage={effortObj?.effort_rate}
            changeEffortRatePercentage={handleRentPercSave}
            value={100}
          />
        </div>
      )}
    </div>
  );
};

export default EffortRateBar;
